import { useQuery } from '@tanstack/react-query';
import { getBrowserClient } from '@/lib/supabase';
import { useHostessStore } from '@/stores/hostess';
import type { ReservationStats } from '@/lib/api/reservations';

export function useReservationStats() {
  const { hostess } = useHostessStore();
  const hostessId = hostess?.id;

  return useQuery<ReservationStats>({
    queryKey: ['reservation-stats', hostessId],
    queryFn: async () => {
      const supabase = getBrowserClient();
      const { data, error } = await supabase.rpc('get_reservation_stats', {
        p_hostess_id: hostessId!,
      });

      if (error) throw new Error(`予約統計取得エラー: ${error.message}`);

      const row = (data as any)?.[0];
      return {
        year: {
          同伴: Number(row?.year_accompanied ?? 0),
          確約: Number(row?.year_confirmed ?? 0),
          予約: Number(row?.year_reserved ?? 0),
        },
        allTime: {
          同伴: Number(row?.alltime_accompanied ?? 0),
          確約: Number(row?.alltime_confirmed ?? 0),
          予約: Number(row?.alltime_reserved ?? 0),
        },
      };
    },
    enabled: !!hostessId,
    staleTime: 30 * 1000, // 30秒キャッシュ
  });
}
